import img from "../assets/images/en-dev.png";

function EnDevelopment() {
  return (
    <div className="w-full h-screen">
      <div className="mx-auto flex space-y-5 flex-col justify-center items-center">
        <div className="w-96">
          <img src={img} alt="" />
        </div>
        <div className="font-bold text-center text-2xl text-black">
          En Développement
        </div>
      </div>
    </div>
  );
}

export default EnDevelopment;
